<template>
  <div class="operation">
    <SearchPrivacyAgree
      :operation="operation"
      :operType="operType"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :multipleSelection="multipleSelection"
      @update="currentChange"
    ></SearchPrivacyAgree>
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="dataList"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          type="selection"
          width="40"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          :label="'Nick name'"
          width="240"
          :align="'center'"
        ></el-table-column>
        <el-table-column
            prop="userName"
            :label="'User name'"
            width="240"
            :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('authority.PrivacyAgreementInfo.972705-0')"
          :align="'center'"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import SearchPrivacyAgree from "@/components/authority/log/SearchPrivacyAgree";

export default {
  name: "PrivacyAgreementInfo",
  components: {
    SearchPrivacyAgree,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      page: {
        pageSize: 10,
        pageIndex: 1,
      },
      operation: {
        startTime: "",
        endTime: "",
        userName: "",
        nickName:""
      },
      operType: [],
      multipleSelection: [],
    };
  },
  mounted() {
    this.currentChange();
    this.listDict();
  },
  methods: {
    listDict() {
      this.$api.dict("sys_operate").then((res) => {
        if (res.code === 0) {
          this.operType = res.data;
        }
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.currentChange();
    },
    currentChange(pageIndex) {
      this.loading = !this.loading;
      this.page.pageIndex = pageIndex ? pageIndex : 1;
      this.$api
        .request(
          this.$url.PrivacyAgreement.page,
          this.$method.get,
          this.$cloud.objMerge(this.operation, this.page)
        )
        .then(
          (res) => {
            if (res.code === 0) {
              if (res.data && res.data.records) {
                this.dataList = res.data.records;
                this.page.totalSize = parseInt(res.data.total);
              }
            }
            this.loading = !this.loading;
          },
          () => {
            this.loading = !this.loading;
          }
        );
    },
    handleSelectionChange(row) {
      this.multipleSelection = row;
    },

    onSubmit() {
      this.currentChange();
    },

    resetSearch() {
      this.currentChange();
    },
  },
};
</script>

<style lang="scss">
.el-dialog__header {
  padding: 20px;
}
.el-dialog__body {
  padding: 0 20px;
  height: auto !important;
}
.el-dialog__footer {
  padding: 20px;
}
.operation {
  .el-form .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
    .el-col {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>
